import { AssetReference } from '@opallabs/cassini'
import { renderIcon } from '@opallabs/kuiper'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { sharedStyles, sharedColors } from '../../sharedStyles/styles'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  isMobile: boolean
}

export const ThreadsSingleHeader: React.FC<Props> = ({
  accountImage,
  accountName,
  isMobile,
}) => {
  return (
    <div css={styles.getAccountHeaderWrapper(isMobile)}>
      <div css={sharedStyles.flexRow}>
        <div css={sharedStyles.flexColumnGutter}>
          <ContentAvatar assetReference={accountImage} size={40} />
        </div>
        <div css={sharedStyles.flexColumn}>
          <AccountName
            name={accountName}
            size={15}
            color={sharedColors.darkGreyText}
            style={styles.getAccountName(isMobile)}
          />
        </div>
        <div css={sharedStyles.flexColumnGutter}>
          <div css={styles.metaWrapper}>
            <div css={styles.timestamp}>1m</div>
            {renderIcon('instagram-desktop-more', { ariaMode: 'hidden' })}
          </div>
        </div>
      </div>
    </div>
  )
}
